import React from 'react'
import * as Dropdown from 'component/base/Form/Dropdown'

export const OshiraseHyojiTaishoKbn = props => {
  return <Dropdown.Static kubunKey='oshirase_hyoji_taisho_kbn' {...props} />
}
